export const zeroUID =
  "0x0000000000000000000000000000000000000000000000000000000000000000";
